import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { createSelectors } from '~/shared/lib/zustand-utils'
import { PINNED_FILTERS_STORAGE_KEY } from '../config'
import type { PinnableConsignmentFilterKey } from './types'

interface PinnedFiltersStore {
  pinnedFilters: PinnableConsignmentFilterKey[]
  setPinnedFilters: (pinnedFilters: PinnableConsignmentFilterKey[]) => void
}

const pinnedFiltersStore = createSelectors(
  create<PinnedFiltersStore>()(
    persist(
      (set) => ({
        pinnedFilters: [],
        setPinnedFilters: (pinnedFilters: PinnableConsignmentFilterKey[]) => set({ pinnedFilters }),
      }),
      { name: PINNED_FILTERS_STORAGE_KEY },
    ),
  ),
)

export const usePinnedFiltersSelectors = () => {
  const pinnedFilters = pinnedFiltersStore.use.pinnedFilters()
  const setPinnedFilters = pinnedFiltersStore.use.setPinnedFilters()
  return { pinnedFilters, setPinnedFilters }
}
